// extracted by mini-css-extract-plugin
export default {"container":"search-field_container__PRag4","iconWrapper":"search-field_iconWrapper__2JIh9","input":"search-field_input__9XPIh","iconColor":"search-field_iconColor__-cU0m"};